export const MassMessagingStatusEnum = Object.freeze({
    CREATED_STATUS: 0,
    STARTED_STATUS: 1,
    COMPLETED_STATUS: 2,
    CANCELLED_STATUS: 3,
    ON_HOLD_STATUS: 4,
    WAITING_FOR_QUOTA: 5,
});